<template>
  <sModal
    v-model="open"
    data-qa="offer-different-price-dialog"
    :title="title"
    @close="close">
    <sAlert
      class="px-4 py-4"
      data-qa="lot-title"
      small>
      {{ element ? element.lotTitle : '' }}
    </sAlert>
    <div
      v-if="element && element.lotId"
      class="flex mt-6">
      <div
        class="s-col"
        data-qa="current-price">
        <div class="h9-label">
          {{ $t('Tenders.CurrentPrice') }}
        </div>
        <div
          data-qa="current-price-value">
          <ShowValueRoundingDigit
            class="h7-text"
            :minimum-fraction-digits="2"
            :value="element.currencyPrice"/>
          {{ tender.currency ? tender.currency.title : ' –' }}
        </div>
      </div>
      <div
        class="s-col"
        data-qa="new-price">
        <div class="h9-label">
          {{ $t('Tenders.NewPrice') }}
        </div>
        <div
          class="h7-text"
          data-qa="new-price-value">
          <ShowValueRoundingDigit
            :minimum-fraction-digits="2"
            :value="new_price"/>
          {{ tender.currency ? tender.currency.title : ' –' }}
        </div>
      </div>
      <div
        class="s-col"
        data-qa="amount">
        <div class="h9-label">
          {{ $t('Catalog.Amount') }}
        </div>
        <div
          class="h7-text"
          data-qa="amount-value">
          <ShowValueRoundingDigit
            :minimum-fraction-digits="2"
            :value="element.selectedQuantity || element.quantity"/>
          {{ element.unit ? element.unit.title : ' –' }}
        </div>
      </div>
    </div>
    <div class="pt-6">
      <div class="h8-text">
        {{ $t('Tenders.NewPrice') }}
      </div>
      <sForm
        ref="form"
        :model="formData"
        :rules="rules">
        <OfferDifferentPriceRadio
          :currency="currency"
          :error.sync="value_error"
          :is-sale="isSale"
          :model_radio.sync="new_price_mode"
          :model_text.sync="formData.value"/>
        <sFormItem
          prop="commment">
          <div class="mt-4">
            <sInput
              clearable
              :placeholder="$t('Common.OptionalComment')"
              show-word-limit
              trim
              type="textarea"
              :value.sync="formData.commment"/>
          </div>
        </sFormItem>
      </sForm>
    </div>
    <div
      key="footer"
      slot="footer"
      class="flex">
      <SendOfferDifferentPrice
        :btn_text="$t('Catalog.Send')"
        :check-validation="checkValidation"
        :disabled="value_error"
        :row="send_model"
        :tender-id="tender.tenderId"
        @send="close"/>
      <sButton
        type="text"
        @click="close">
        {{ $t('Common.Cancel') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
import ShowValueRoundingDigit from 'components/common/blocks/ShowValueRoundingDigit.vue'
import SendOfferDifferentPrice from 'components/tenders/tender page/offer different price/SendOfferDifferentPrice.vue'
import OfferDifferentPriceRadio from 'components/tenders/tender page/offer different price/OfferDifferentPriceRadio.vue'

import { modalMixin } from 'mixins'

export default {
  name: 'offerDifferentPriceDialog',
  mixins: [ modalMixin ],
  data() {
    const that = this
    return {
      rules: {
        value: [
          {
            validator: (rule, value, callback) => {
              that.validateInput(rule, 
                {price: this.new_price, percent: that?.new_price_mode === 'PRICE' ? null : this.formData.value},
                callback,
                that?.new_price_mode,
                true,
                that.element?.lotId
              )
            },
          },
        ],
      },
      formData: {
        value: '',
        commment: ''
      },
      loading: false,
      new_price_mode: 'PRICE',
      new_price_difference: null,
      value_error: false,
      currencies: []
    }
  },
  props: {
    tender: Object,
    element: Object,
    dialog: Boolean,
    validateInput: Function,
    getNewPrice: Function,
    isSale: Boolean
  },
  async created() {
    await this.$store.dispatch('setCurrencies')
      .then(res => this.currencies = res)
  },
  computed: {
    title() {
      return this.$t('Tenders.PriceUpdateRequestFor') +
        (this.element && this.element?.bidderInfo ?
          '"' + ( this.element?.bidderInfo?.organizationName || this.element?.bidderInfo?.fullName ) + '"'
          : '–')
    },
    currency() {
      return this.getCurrency(this.element)
    },
    new_price() {
      return this.getNewPrice(this.element?.currencyPrice, this.formData.value, this.new_price_mode)
    },
    send_model() {
      return  {
        bidItemId: this.element?.id ,
        price: this.new_price,
        comment: this.formData.commment
      }

    },
    open: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      }
    },
  },
  methods: {
    close() {
      this.$refs.form.clearValidate( )
      this.new_price_mode = 'PRICE'
      this.new_price_difference = null
      this.$emit('close')
    },
    async checkValidation() {
      return await this.$refs.form.validate().catch(res => {
        if ( this.new_price_mode == 'PERSENT' && !this.isSale && this.formData.value > 99.99) {
          this.$notice.info({
            title: '',
            message: this.$t('Tenders.TheDiscountCannotBeMoreThan99'),
            showClose: true,
            progress: true,
            duration: 20
          })
        }
        return res
      })
    },
  },
  components: {
    ShowValueRoundingDigit,
    SendOfferDifferentPrice,
    OfferDifferentPriceRadio,
  }
}
</script>
